<!--img component-->
<template>
    <div class="common-lazy-img">
        <img v-lazy="source" :alt="alt || ''" src="" />
    </div>
</template>

<script>
import { webpImg, trimHttp, drp } from '../utils/index';

export default {
    props: {
        src: {},
        width: {},
        height: {},
        alt: {},
        webp: {
            default: true
        },
        hd: {
            default: true
        },
        cut: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ratio() {
            return this.hd ? drp() : 2;
        },
        source() {
            if (this.webp) {
                return webpImg(this.src, Math.ceil(this.width * this.ratio), Math.ceil(this.height * this.ratio), this.cut);
            } else {
                return trimHttp(this.src);
            }
        }
    }
};
</script>

<style lang="less">
.common-lazy-img {
    background: url('../images/img_loading.png') center center no-repeat;
    background-size: 50px;
    width: 100%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    img {
        display: block;
        width: 100%;
        height: 100%;
        &[src=''] {
            opacity: 0
        }
    }
}
</style>
